// Frontend: TableRow.jsx
import React, { useState } from 'react';
import Classes from './RecordTable.module.css';
import { useNavigate } from 'react-router-dom';
import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';
import { CalenderIcon } from '../../../../../../../utils/Icons';
import NotifyPopup from '../../../../../../GlobalComponents/NotifyPopup/NotifyPopup';
import ReschedulePopup from './ReschedulePopup/ReschedulePopup';
import { AnimatePresence } from 'framer-motion';
import CancelConfirmPopup from '../../../../../../GlobalComponents/CancelConfirmPopup/CancelConfirmPopup';
import TrackPopup from './TrackPopup/TrackPopup';
import backend from '../../../../../../../api';
import { useSelector } from 'react-redux';
import TipPopup from './TipPopup/TipPopup';

export default function TableRow({ value, isAppointments, onChanged }) {
  const navigateTo = useNavigate();
  const { token } = useSelector((s) => s?.auth || {});
  const company = useSelector((s) => s?.companyInfo?.info || {});
  const booking = value?.raw;

  const [openReschedulePopup, setOpenReschedule] = useState(false);
  const [openNotifyPopup, setOpenNotify] = useState(false);
  const [openConfirmPopup, setOpenConfirm] = useState(false);
  const [openTrackPopup, setOpenTrack] = useState(false);
  const [openTipPopup, setOpenTip] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleSubmitReschedule = async (next) => {
    try {
      setBusy(true);
      const resp = await backend.post(
        `/api/bookings/${booking._id}/reschedule`,
        next,
        { headers: token ? { Authorization: `Bearer ${token}` } : undefined }
      );
      if (resp?.data?.ok) {
        setOpenReschedule(false);
        setOpenNotify(true);
        onChanged?.();
      } else {
        alert(resp?.data?.error || "Could not reschedule.");
      }
    } catch (e) {
      alert(e?.response?.data?.error || e.message);
    } finally {
      setBusy(false);
    }
  };

  const handleConfirmSubmit = async () => {
    try {
      setBusy(true);
      const amount = Number(booking?.pricing?.total || 0);
      const paymentIntentId = booking?.stripe?.paymentIntentId || booking?.stripe?.sessionId || "";
      const stripeAccountId = company?.stripeAccountId || undefined;
      const platformFee = Number(company?.platformFee || 0);
      if (!paymentIntentId || !amount) {
        alert("Missing payment details for refund.");
        setBusy(false);
        return;
      }
      const payload = { stripeAccountId, paymentIntentId, amount, platformFee, bookingId: booking._id };
      const resp = await backend.post("/pay/refund", payload, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
      if (resp?.data?.ok) {
        setOpenConfirm(false);
        onChanged?.();
      } else {
        alert(resp?.data?.error || "Cancel failed.");
      }
    } catch (e) {
      alert(e?.response?.data?.error || e.message);
    } finally {
      setBusy(false);
    }
  };

  const bookingId = booking._id;

  const handleTipSubmit = async (tipAmount) => {
    try {
      setBusy(true);
      const { data } = await backend.post('/pay/create-tip-session', {
        bookingId: bookingId,
        tipAmount,
      }, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert('Failed to create tip session.');
      }
    } catch (e) {
      alert(e?.response?.data?.error || e.message);
    } finally {
      setBusy(false);
      setOpenTip(false);
      onChanged?.();
    }
  };

  return (
    <>
      <div className={Classes.customerRow} key={value._id}>
        <div className={`${Classes.rowElem} ${Classes.elem1}`}><h5>{value.service}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem2}`}><h5>{value.amount}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem3}`}><h5>{value.bookingDate}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem4}`}><h5>{value.serviceDate}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem5}`}>
          <DropDown selectedValue={value.status.label} options={["completed","upcoming","cancelled","on_the_way","delayed"]} isDropDown={false} />
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem6}`}><h5 onClick={() => setOpenTrack(true)}>Track</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem7}`}>
          <MoreDropDown
            booking={booking}
            handleopenReschedulePopup={() => setOpenReschedule(true)}
            handleOpenConfirmPopup={() => setOpenConfirm(true)}
            handleOpenTipPopup={() => setOpenTip(true)}
            disabled={busy}
          />
        </div>
      </div>

      {/* Mobile stacked row */}
      <div className={Classes.customerRowMobile}>
        <div>
          <div className={Classes.mobElem}><h4>Service</h4><h5>{value.service}</h5></div>
          <div className={Classes.mobElem}><h4>Amount</h4><h5>{value.amount}</h5></div>
          <div className={Classes.mobElem}><h4>Booking Date</h4><h5>{value.bookingDate}</h5></div>
        </div>
        <div>
          <div className={Classes.mobElem}>
            <h4>Status</h4>
            <DropDown selectedValue={value.status.label} options={["completed","upcoming","cancelled","on_the_way","delayed"]} isDropDown={false} />
          </div>
          <div className={Classes.mobElem}><h4>Service Date</h4><h5>{value.serviceDate}</h5></div>
          <div className={Classes.mobElem}><h4 onClick={() => setOpenTrack(true)}>Track</h4><h5 style={{ color: 'var(--primary-color)' }}>Track</h5></div>
        </div>

        <MoreDropDown
          booking={booking}
          handleopenReschedulePopup={() => setOpenReschedule(true)}
          handleOpenConfirmPopup={() => setOpenConfirm(true)}
          handleOpenTipPopup={() => setOpenTip(true)}
          disabled={busy}
        />
      </div>

      <AnimatePresence>
        {openReschedulePopup && (
          <ReschedulePopup
            booking={booking}
            closePopup={() => setOpenReschedule(false)}
            submitPopup={handleSubmitReschedule}
            busy={busy}
          />
        )}
      </AnimatePresence>

      <AnimatePresence exit="wait">
        {openNotifyPopup && (
          <NotifyPopup
            closePopup={() => setOpenNotify(false)}
            submitPopup={() => { setOpenNotify(false); navigateTo('/appointments'); }}
            title="Appointment Changed"
            description={`Your new appointment is at ${booking?.appointment?.date || ''} ${booking?.appointment?.timeSlot || ''}`}
            buttonText="Return"
            icon={<CalenderIcon fill={'white'} height='50px' />}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {openConfirmPopup && (
          <CancelConfirmPopup
            handleClose={() => setOpenConfirm(false)}
            handleSubmit={handleConfirmSubmit}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {openTrackPopup && (
          <TrackPopup
            closePopup={() => setOpenTrack(false)}
            submitPopup={() => setOpenTrack(false)}
            booking={booking}
          />
        )}
      </AnimatePresence>

      {/* Tip Popup */}
      <AnimatePresence>
        {openTipPopup && (
          <TipPopup
            booking={booking}
            closePopup={() => setOpenTip(false)}
            submitPopup={handleTipSubmit}
            busy={busy}
          />
        )}
      </AnimatePresence>
    </>
  );
}
